import {
  CLEAR_STORE,
  DESTROY_USER_FLOW,
  SCREEN_FLOW,
  TIMELINE_FLOW,
  UPDATE_SCREEN_OBJECT,
  UPDATE_TIMELINE,
  UPDATE_USER_FLOW,
  USER_FLOW_JUMP_TO,
  USER_FLOW_JUMP_WITH_TIMELINE_CHANGE,
  USER_FLOW_NEXT,
  USER_FLOW_PREV,
  UPDATE_TIMELINE_CONFIG,
  CHANGE_SCREEN_CONFIG,
  UPDATE_DOCUMENT_TIMELINE_CONFIG,
  ONLY_ACK_SCREEN,
  PRE_SELECT_PAYMENT_METHOD,
  STORE_DHA_CHALLAN_DATA
} from '../../action-contants';
import uniqBy from 'lodash/uniqBy';

const INITIAL_STATE = {
  screens: [],
  currentScreen: '',
  timeline: [],
  documentTimeLine: {},
  ackScreenShown: false,
  preSelectedPaymentMethod: null,
  beneficiaryList: [],
  dhaChallanData: null
};

export default function userFlowReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CLEAR_STORE: {
      return INITIAL_STATE;
    }
    /* screens */
    case SCREEN_FLOW: {
      return {
        ...state,
        screens: action.data.screens,
        currentScreen: action.data.currentScreen
      };
    }

    case UPDATE_USER_FLOW: {
      return { ...state, screens: action.data.screens };
    }

    case CHANGE_SCREEN_CONFIG: {
      return {
        ...state,
        screens: uniqBy(action.screens, 'name')
      };
    }
    case USER_FLOW_JUMP_TO: {
      return { ...state, currentScreen: action.data };
    }
    case USER_FLOW_JUMP_WITH_TIMELINE_CHANGE: {
      return { ...state, currentScreen: action.data };
    }

    case USER_FLOW_NEXT: {
      return { ...state, currentScreen: action.data };
    }

    case USER_FLOW_PREV: {
      return { ...state, currentScreen: action.data };
    }

    /* timeline */
    case TIMELINE_FLOW: {
      return { ...state, timeline: action.data };
    }

    case UPDATE_TIMELINE: {
      return {
        ...state,
        timeline: action.data.timeline,
        currentScreen: action.data.currentScreen
      };
    }

    case UPDATE_TIMELINE_CONFIG: {
      return { ...state, timeline: action.data };
    }

    case UPDATE_SCREEN_OBJECT: {
      let screens = [...(state.screens || [])],
        index = screens.findIndex(({ name }) => name === action.data.screen);
      if (index === -1) return state;
      screens[index] = Object.assign(screens[index], action.data.status);
      return state;
      /*
      let prevstatus, newstatus, index;
      newstatus = action.data.status;
      let screens = [...state.screens];
      for (let i = 0; i < screens.length; i++) {
        if (screens[i].name === action.data.screen) {
          prevstatus = screens[i];
          index = i;
          break;
        }
      }
      newstatus = {...prevstatus, ...newstatus};
      screens[index] = newstatus;
      return {...state, screens: screens};*/
    }

    case UPDATE_DOCUMENT_TIMELINE_CONFIG: {
      return { ...state, documentTimeLine: action.data };
    }

    //------------------------------------------destroy---------------------------------//

    case DESTROY_USER_FLOW: {
      return {
        ...state,
        screens: null,
        currentScreen: null,
        timeline: null,
        documentTimeLine: null
      };
    }

    //-------------------------------------- ACK Screen to be shown once in SG------------//
    case ONLY_ACK_SCREEN: {
      return { ...state, ackScreenShown: action.data };
    }

    case PRE_SELECT_PAYMENT_METHOD: {
      return {
        ...state,
        preSelectedPaymentMethod: action.data
      };
    }

    case STORE_DHA_CHALLAN_DATA: {
      return { ...state, dhaChallanData: action.data };
    }

    default:
      return state;
  }
}
